
import React, { Component } from 'react';
import PubSub from 'pubsub-js';
import { Input, Form, Button } from "antd";
import share from "../../../imgs/item/share.png";
import user_admin from "../../../imgs/item/user_admin.png";
import user_normal from "../../../imgs/item/user_normal.png";
import map_del from "../../../imgs/btn/map_del.png";
import arrow_back from "../../../imgs/btn/arrow_back.png";
import { meshLog, SPGet, SPSet } from "../../../utils/spUtils";
import './permissionDialog.less';
import { Attention_DIALOG_HIDE, Attention_DIALOG_SHOW, Attention_Share, PERMISSION_DIALOG_HIDE } from '../../../const/infoConst';
import { deleteShareBuildingData, getQRReceiverDataList } from '../../../utils/net/netUtils';
const { Item } = Form;

let isCancel=false;
let share_email="";
export default class PermissionDialog extends Component {   
    constructor(props) {
        super(props);
        this.state = {
            mPage:0, //0-分享界面 1-列表界面
            selectedInvite:"User", //User  Admin
            mList: [], 
        };
    }

    componentDidMount() {
        PubSub.subscribe(Attention_DIALOG_HIDE, (msg, index) => {
            if(index==Attention_Share && share_email==SPGet("delete_share_email")){
                meshLog('删除share', share_email);
                deleteShareBuildingData(share_email).then((res) => {
                    meshLog('删除账户成功', res);
                    let list=this.state.mList.filter(item => item.receiver !== share_email);
                    this.setState({
                        mList:list,
                    });
                }).catch((err) => {
                    meshLog('删除账户失败', err);
                });
            }  
        })
    }


    //-----------------------------------分享界面----------------------------------------------
    //普通权限
    handleRadioChangeUser = (e) => {
        this.setState({selectedInvite:"User"})
    };
    //管理员权限
    handleRadioChangeAdmin = (e) => {
        this.setState({selectedInvite:"Admin"})
    };
    //取消
    cancelClick= () => {
        meshLog('取消1');
        isCancel=true;
        PubSub.publish(PERMISSION_DIALOG_HIDE, '');
    };

    //保存
    handleSubmit = async (values) => {
        if(isCancel){
            isCancel=false;
            return;
        }
        const { name } = values;
        meshLog('name',name);
        PubSub.publish(PERMISSION_DIALOG_HIDE, '');
    }

    //-----------------------------------列表界面----------------------------------------------
    //获取账户列表
    getAccListClick() {
        getQRReceiverDataList().then((list) => {
            meshLog('list', list);
            this.setState({
                mList: list,
                mPage:1,
            });
        }).catch((err) => {
            meshLog('获取账户列表失败', err);
        });
    }

    //删除账户
    delAccClick= (receiver) => {
        SPSet("delete_share_email", receiver);
        PubSub.publish(Attention_DIALOG_SHOW,Attention_Share);
        share_email=receiver;
    }

    //返回
    backBtnClick= () => {
        this.setState({
            mPage:0,
        });
    }



    render() {
        const { selectedInvite ,mPage} = this.state;
        return (
            <div className="permiss-container">
                <div className="ui_grey_bg" />
                <div className="permiss_dialog" style={{ display: mPage==0 ? "block" : "none" }}>
                    {/* 1. Area Management 标题行 */}
                    <div className="permiss-row">
                        <div className="permiss-title">
                            <span>Permission Sharing</span>
                            <img className='icon' src={share} onClick={()=>this.getAccListClick()}/>
                        </div>
                    </div>

                    {/* 邮箱 */}
                    <Form layout="vertical" onFinish={this.handleSubmit} requiredMark={false}>
                        <div className='emailBg'>
                            <span>Invite collaborators</span>
                        </div>

                        <Item name="name" rules={[{ required: true, message: 'Please input your Area name!' }]}>
                            <Input  placeholder="*Email Address" />
                        </Item>

                        {/* 权限 */}
                        <div className='userBg'>
                            <div className="user-title">
                                <span>User</span>
                                <input className="radioSet" type='radio' name='invite' value='' style={{accentColor:'#FFBD27'}} checked={selectedInvite=="User"} onChange={this.handleRadioChangeUser}/>
                            </div>
                            <span>Can only view the project and control the light. </span>
                            <span>Cannot make any changes</span>
                        </div>

                        <div className='adminBg'>
                            <div className="admin-title">
                                <span>Admin</span>
                                <input className="radioSet" type='radio' name='invite' value='' style={{accentColor:'#FFBD27'}} checked={selectedInvite=="Admin"} onChange={this.handleRadioChangeAdmin}/>
                            </div>
                            <span>Can make changes in the project.</span>
                            <span>Can add andmanage devices.</span>
                            <span>*No permission to delete or modify Building.</span>
                        </div>


                        {/* 底部按钮 */}
                        <div className="permiss-footer">
                            <button className='cancelBtn' onClick={()=>this.cancelClick()}>Cancel</button>
                            <Button className='okBtn' htmlType='submit'>Confirm</Button>
                        </div>
                    </Form>
                </div> 

                <div className="account_dialog" style={{ display: mPage==1 ? "block" : "none" }}>
                    <img className='acc_back' src={arrow_back} onClick={()=>this.backBtnClick()}/>
                    <div className='acc_title'><span>Permission Management List</span></div>
                    {/* 账户列表 */}
                    <div className="acc_list">
                        {this.state.mList.map((item) => (
                            <div className="acc_item" key={item.id}>
                                <img className='acc_icon' src={item.role==1?user_admin:user_normal} />
                                <span className='acc_email'>{item.receiver}</span>
                                <span className='acc_role'>{item.role==1?"Admin":"User"}</span>
                                <img className='acc_del' src={map_del} onClick={() => this.delAccClick(item.receiver)} />
                            </div>
                        ))}
                    </div>
                </div>


            </div>
        );
    }
}
